attachEvent('.cocktail-mixing .cocktail-card__link', 'click', (ev) => {
  const parentElem = ev.target.closest('.cocktail-mixing');
  parentElem.classList.toggle('is-open');

  if (windowWidth() < breakpointMd) {
    const contentElem = parentElem.querySelector('.cocktail-mixing__content');
    const { top } = contentElem.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.scrollTo({
      top: top + scrollTop,
      behavior: 'smooth',
    });
  }
});

attachEvent('.cocktail-mixing__back', 'click', (ev) => {
  const parentElem = ev.target.closest('.cocktail-mixing');
  parentElem.classList.remove('is-open');
});

const axiosGetCocktailInfo = async (parentElem, action, selectedTaste, selectedType) => {
  const axiosData = {
    action,
    selectedTaste,
    selectedType,
    nonce: await getNonceForAction(action),
  };

  try {
    const { data } = await axios.post(localData.siteURL, axiosData);

    const cocktailRecipe = parentElem.querySelector('.cocktail-mixing__recipe-inner');
    const cocktailNotFound = parentElem.querySelector('.cocktail-mixing__not-found');

    cocktailRecipe.innerHTML = data.data.postsHtml;
    cocktailNotFound.classList.toggle('hide', data.data.postsHtml);
    cocktailRecipe.classList.toggle('hide', !data.data.postsHtml);
  } catch (err) {
    console.error(err);
  }
};

attachEvent('.cocktail-mixing .selection-slider .mod-tag', 'click', (ev) => {
  const parentElem = ev.target.closest('.cocktail-mixing');
  const parentList = ev.target.closest('.selection-slider');
  const currentActiveItem = parentList.querySelector('.is-active');

  toggleActiveClass(currentActiveItem, false);
  toggleActiveClass(ev.target, true);

  const selectedTaste = parentElem.querySelector('.cocktail-mixing__taste-slider .is-active').dataset.slug;
  const selectedType = parentElem.querySelector('.cocktail-mixing__types-slider .is-active').dataset.slug;
  const action = parentElem.querySelector('[data-action]').value;

  axiosGetCocktailInfo(parentElem, action, selectedTaste, selectedType);
});
